<div *ngIf="student && genders && extraInfos" class="w-100">

    <div class="row mb-2">

        <div class="col-12 col-lg-6">
            <app-student-edit-general
                [(student)]="student"
                [genders]="genders"
                (isStudentValid)="isStudentGeneralDataValidEvent($event)">
            </app-student-edit-general>
        </div>

        <div class="col-12 col-lg-6">
            <app-student-edit-school
                [(student)]="student"
                (isStudentValid)="isStudentSchoolDataValidEvent($event)">
            </app-student-edit-school>
        </div>

    </div>

    <div class="row mb-2">

        <div class="col-12">
            <app-student-edit-extra-info
                [(student)]="student"
                [extraInfos]="extraInfos"
                (isStudentValid)="isStudentExtraInforDataValidEvent($event)">
            </app-student-edit-extra-info>
        </div>

    </div>

    <div class="row mb-2">

        <div class="col-12">

            <div class="d-flex flex-column justify-content-center align-items-start w-100">

                <button type="button" class="btn button-accent-color w-100 py-2"
                    [disabled]="!isFormValid() || isProcessing"
                    (click)="createOrUpdateEntity()">

                    <div *ngIf="isEdition && !isProcessing" class="w-100">
                        <fa-icon [icon]="['fas', 'floppy-disk']" class="me-1"></fa-icon>
                        <span class="fs-6">Guardar</span>
                    </div>

                    <div *ngIf="!isEdition && !isProcessing" class="w-100">
                        <fa-icon [icon]="['fas', 'plus']" class="me-1"></fa-icon>
                        <span class="fs-6">Crear</span>
                    </div>

                    <div *ngIf="isProcessing" class="d-flex flex-row justify-content-center align-items-center w-100">
                        <fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>
                    </div>

                </button>

                <p-message
                    class="w-100 my-2"
                    styleClass="w-100"
                    *ngIf="processingMessage.show"
                    [severity]="processingMessage.severity"
                    [text]="processingMessage.text">
                </p-message>

            </div>

        </div>

    </div>

</div>
